export default "__VITE_ASSET__CqRgoB1g__"